import type { AppModule } from '@/shared/types';
import * as routes from './routes';

export const ProfileModule: AppModule = {
  routes,
};
